import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';

const getElementOffsetTop = (element)=>{
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    return element ? element.getBoundingClientRect().top + scrollTop : 0;
};
const useScrollToField = (fieldName, callback)=>{
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    React.useEffect(()=>{
        var ref;
        if (!fieldName) {
            return;
        }
        const headerOffset = isMobile ? 160 : 110;
        var ref1;
        const element = (ref1 = (ref = document.getElementsByName(fieldName)) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : null;
        if (!element) {
            return;
        }
        /** Get top position of the fieldName */ const top = getElementOffsetTop(element);
        /** Scroll to this fieldName with static offset based on the viewport */ window.scrollTo(0, top - headerOffset);
        callback && callback();
    }, [
        fieldName,
        isMobile,
        callback
    ]);
};

export { useScrollToField };
//# sourceMappingURL=use-scroll-to-field.js.map
